
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from "@/components/ui/separator";

const Integritetspolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="container mx-auto px-4 pt-32 pb-16 max-w-4xl">
        <h1 className="text-3xl font-bold text-darkgray mb-6 font-montserrat">Integritetspolicy</h1>
        
        <div className="prose prose-yellow max-w-none space-y-6 text-darkgray/80 font-opensans">
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">1. Inledning</h2>
            <p>Välkommen till Snabbaupphandlingar ("vi", "vår", "oss"). Vi värnar om din integritet och strävar efter att skydda dina personuppgifter i enlighet med gällande dataskyddslagstiftning, inklusive EU:s allmänna dataskyddsförordning (GDPR).</p>
            <p>Denna integritetspolicy förklarar hur vi samlar in, använder, lagrar och skyddar dina personuppgifter när du använder vår webbplats och tjänster för anbudsanalys och upphandlingsstöd.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">2. Uppgifter vi samlar in</h2>
            <p>Vi samlar in följande typer av personuppgifter:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Kontaktuppgifter: namn, e-postadress, telefonnummer, företagsuppgifter</li>
              <li>Profilinformation: företagsstorlek, bransch, tidigare upphandlingserfarenhet</li>
              <li>Användardata: IP-adress, webbläsartyp, besökta sidor, tidpunkt för besök</li>
              <li>Kommunikation: e-postmeddelanden och annan korrespondens mellan dig och oss</li>
              <li>Upphandlingsdata: information om upphandlingar du analyserat eller bevakar</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">3. Hur vi använder dina uppgifter</h2>
            <p>Vi använder dina personuppgifter för att:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Tillhandahålla och förbättra våra anbudsanalyser och upphandlingstjänster</li>
              <li>Hjälpa dig navigera och analysera offentliga upphandlingar genom vår AI-baserade plattform</li>
              <li>Kommunicera med dig angående våra tjänster och relevanta upphandlingsmöjligheter</li>
              <li>Skicka relevant information om nya upphandlingar och nyhetsbrev (om du har samtyckt till detta)</li>
              <li>Hantera din användning av vår plattform för upphandlingsanalys</li>
              <li>Uppfylla våra juridiska skyldigheter inom området för upphandlingsprocesser</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">4. Laglig grund för behandling</h2>
            <p>Vi behandlar dina personuppgifter på följande rättsliga grunder:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fullgörande av avtal mellan dig och oss gällande upphandlingstjänster</li>
              <li>Ditt samtycke för specifika behandlingsändamål som kräver detta</li>
              <li>Vårt berättigade intresse att utveckla och förbättra våra upphandlingsanalyser</li>
              <li>För att uppfylla rättsliga förpliktelser inom offentlig upphandling</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">5. Delning av personuppgifter</h2>
            <p>Vi kan dela dina personuppgifter med:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Våra tjänsteleverantörer (t.ex. molntjänstleverantörer, betalningsleverantörer)</li>
              <li>Upphandlingspartners när det är nödvändigt för att leverera tjänsten (med ditt samtycke)</li>
              <li>Myndigheter när det krävs enligt lag inom upphandlingsområdet</li>
            </ul>
            <p>Vi säljer aldrig dina personuppgifter till tredje part.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">6. Lagring och säkerhet</h2>
            <p>Vi lagrar dina personuppgifter så länge som det är nödvändigt för att tillhandahålla våra upphandlingstjänster eller så länge som krävs enligt lag.</p>
            <p>Vi har implementerat lämpliga tekniska och organisatoriska åtgärder för att skydda dina personuppgifter mot obehörig åtkomst, förlust eller ändring i samband med vår upphandlingsanalystjänst.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">7. Dina rättigheter</h2>
            <p>Enligt GDPR har du följande rättigheter:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Rätt till tillgång till dina personuppgifter</li>
              <li>Rätt till rättelse av felaktiga personuppgifter</li>
              <li>Rätt till radering ("rätten att bli bortglömd")</li>
              <li>Rätt till begränsning av behandling</li>
              <li>Rätt till dataportabilitet</li>
              <li>Rätt att invända mot behandling</li>
              <li>Rätt att återkalla samtycke</li>
            </ul>
            <p>För att utöva dessa rättigheter gällande din upphandlingsdata, vänligen kontakta oss via kontaktuppgifterna nedan.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">8. Ändringar av denna policy</h2>
            <p>Vi kan komma att uppdatera denna integritetspolicy från tid till annan för att spegla ändringar i vår verksamhet eller rättsliga krav inom upphandlingsområdet. När vi gör det kommer vi att informera dig genom att publicera den uppdaterade versionen på vår webbplats och, om ändringarna är väsentliga, även meddela dig via e-post.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">9. Kontaktinformation</h2>
            <p>Om du har frågor eller funderingar om vår integritetspolicy eller vår behandling av dina personuppgifter i samband med våra upphandlingstjänster, vänligen kontakta oss på:</p>
            <p className="mt-2">
              E-post: kontakt@snabbaupphandlingar.se<br />
              Adress: Skallebackavägen 13, 32 41 Halmstad
            </p>
          </section>
          
          <p className="mt-8 text-sm">Senast uppdaterad: 1 juni 2024</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Integritetspolicy;
